// extracted by mini-css-extract-plugin
export var pagination = "style-module--pagination--87433";
export var paginationButton = "style-module--paginationButton--12958";